import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../shared/config/app-config';
import { UserService } from '../../shared';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css']
})
export class DocumentsComponent implements OnInit {
  ModelRef: BsModalRef
  constructor(private userService:UserService,private Modalservice:BsModalService) { }
  currentuserDetails:any={}
  resp:any=[]
  loginUserAccountId:number
  ngOnInit() {
    this.userService.currentUser.subscribe(data=>{
      this.currentuserDetails=data
      if (this.currentuserDetails.item) {
        if (window.localStorage['ccdetails']) {
          let ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
          this.loginUserAccountId = ccdetails.cnuseraccid
        } else {
          this.loginUserAccountId = this.currentuserDetails.item.userAccountId
        }
      }
    })
    this.userService.PUser.subscribe(
      (puserData) => {
        this.resp = puserData;
      }
    )
    
    this.fetchAllPatientDocument()
    this.updateCountForPatientDocument(this.loginUserAccountId)
  }
  /* ----------------get all Documentlist------------- */
  patientDocuments = []
  fetchAllPatientDocument()
  {
    var patientSwfId={"patientSwfId":window.localStorage['Puser']}
    this.userService.fetchAllPatientDocument(patientSwfId).subscribe(data=>{this.patientDocuments=data })
  }

  /* ----------------update viewed document count------------- */
  updateCountForPatientDocument(loginUserAccountId)
  {
    this.userService.updateCountForPatientDocument(loginUserAccountId).subscribe(data=>{
      this.currentuserDetails.item.documentCount = data.viewedDocumentCount
      this.userService.currentUserSubject.next(this.currentuserDetails);
     })
  }

  
/* ----------------print Document------------- */
pdfUrl:any
downloadPatientDocuments:any=environment.downloadPatientDocuments
openModelprint(template: TemplateRef<any>,value) {
  let self = this;
  let data:any= {
    'patientSwfId':String(window.localStorage['Puser']), 
    'fileId':value.fileId,
    'preview':true,
    'loginUserId':String(this.currentuserDetails.item.userAccountId),
    'lang': this.userService.selectedLang()
  }
  data = this.userService.encrypt(JSON.stringify(data))
  data=btoa(data)
  this.pdfUrl=this.downloadPatientDocuments+data+"&type=WEB"
  this.ModelRef = self.Modalservice.show(template, { class: 'modal-lg', backdrop: 'static' })
  document.getElementById("filename").innerHTML=value.filename
} 
/* ----------------Download Document------------- */
downloadDoc(value) {
  let data:any= {
    'patientSwfId':String(window.localStorage['Puser']),
    'fileId':value.fileId,
    'loginUserId':String(this.currentuserDetails.item.userAccountId)
  }
  data = this.userService.encrypt(JSON.stringify(data))
  data=btoa(data)
  window.open(this.downloadPatientDocuments+data+"&type=WEB");
}

printpagenew(): void {
  window.open(this.pdfUrl, '_blank', 'top=0,left=0,height=100%,width=auto');
  this.ModelRef.hide()
}
}
